import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const PROPERTY_SERVICES = {
  ROOT: `${PRIVATE_ROOT}/community/property-services`,
  REQUESTED: `${PRIVATE_ROOT}/community/property-services/requested`,
  SERVICE_OPTIONS: `${PRIVATE_ROOT}/community/property-services/:id/service-options`,
  SCHEDULE_SERVICE: `${PRIVATE_ROOT}/community/property-services/:id/add-schedule-service/:serviceId`,
  ADD_SERVICE: `${PRIVATE_ROOT}/community/property-services/:id/option-detail/:serviceId`,
  UPDATE_SCHEDULE_SERVICE: `${PRIVATE_ROOT}/community/property-services/:id/update-schedule-service/:serviceId`,
  RENT_CREDIT_REPORT: `${PRIVATE_ROOT}/community/property-services/:id/rent-credit-report/esign`,
}
